define('commons/header-list',['jquery', 'utils/form', 'commons/field-validation-errors'], function($, form, fieldValidationErrors) {

    var headerLine = function(lineNumber, key, value, lineClass) {
        return '<li id="header_' + lineNumber + '" data-line-number="' + lineNumber + '" class="headerLine ' +
                (typeof lineClass != 'undefined' ? '' + lineClass + '' : '') + '"><input type="text" placeholder="header" class="header" id="key_' +
                lineNumber + '" name="key_' + lineNumber + '" value="' + key + '" /><input type="text" placeholder="value" id="value_' + lineNumber +
                '" name="value_' + lineNumber + '" value="' + value + '" class="value" data-no-extra="true"/><span id="remove_' + lineNumber + '" data-line-number="' +
                lineNumber + '" class="remove-header-line icon-large icon-remove-sign" /></li>';
    };

    /**
     * Check if the field firstKey is empty while second key is not
     */
    var validateEmptyField = function(firstKey, otherKey, lineNumber) {
        var firstKeyLength = firstKey.val().trim().length;
        var otherKeyLength = otherKey.val().trim().length;

        // Key is empty and value contains data
        if (firstKeyLength == 0 && otherKeyLength > 0) {
            return false;
        }

        return true;
    };

    /**
     * Check that a header field is empty while its associated value is not
     */
    var validateEmptyHeader = function(keyField) {
        var valueField = keyField.next();
        var lineNumber = keyField.data('lineNumber');
        return validateEmptyField(keyField, valueField, lineNumber);
    };

    /**
     * Check that a value field is empty while its associated header is not
     */
    var validateEmptyValue = function(valueField) {
        var keyField = valueField.prev();
        var lineNumber = keyField.data('lineNumber');
        return validateEmptyField(valueField, keyField, lineNumber);
    };

    var validHeaderKeyRegex = /^[!#$%&'*+\-.^`|~\w]+$/;
    /**
     * Check that a header key is not in the list of forbidden headers
     */
    var validateHeaderKeyForbidden = function(forbiddenHeaders, keyInput) {
        var value = keyInput.val();
        return forbiddenHeaders.indexOf(value.toLowerCase()) == -1;
    };

    /**
     * Check that a header key matches the standard format
     */
    var validateHeaderKeyFormat = function(keyInput) {
        var value = keyInput.val();
        return (value.length == 0 || value.match(validHeaderKeyRegex));
    };

    var forbiddenChars = /[\'"<>]/;

    var validHeaderValueFormat = function(keyInput) {
        var value = keyInput.val();
        return !value.match(forbiddenChars);
    };
    
    /**
     * Check that a header value does not already exist
     */
    var validateDuplicateHeaders = function() {
        var canSubmit = true;
        var headers = [];
        $('input.header').removeClass('duplicateHeader').each(function(index, element) {
            var input = $(element);
            fieldValidationErrors.removeError(input, 'duplicateHeader');
            headers.push({
                'line': input.parent().data('lineNumber'),
                'value': input.val()
            });
        });
        var length = headers.length;
        for (var i = 0; i < length; i++) {
            var actualHeader = headers[i].value.toLowerCase();
            var isDuplicated = false;
            if (actualHeader.trim().length > 0) {
                for (var j = i + 1; j < length; j++) {
                    var compared = headers[j].value.toLowerCase();
                    var key = $('#key_' + headers[j].line);
                    if (actualHeader == compared) {
                        key.addClass('duplicateHeader');
                        isDuplicated = true;
                        fieldValidationErrors.addError(key, 'duplicateHeader', 'This header is duplicated');
                    }
                }
                var key = $('#key_' + headers[i].line);
                if (isDuplicated) {
                    canSubmit = false;
                    key.addClass('duplicateHeader');
                    fieldValidationErrors.addError(key, 'duplicateHeader', 'This header is duplicated');
                }
            }
        }
        return canSubmit;
    };

    /**
     * Apply the validations on a single line
     */
    var validateLine = function(forbiddenHeaders) {
        return function() {

            var ok = true;

            // Validate key
            var key = $(this).find('input.header');
            if (!validateHeaderKeyForbidden(forbiddenHeaders, key)) {
                key.addClass('forbiddenHeader');
                fieldValidationErrors.addError(key, 'forbiddenHeader', 'This header is forbidden');
                ok = false;
            } else {
                key.removeClass('forbiddenHeader');
                fieldValidationErrors.removeError(key, 'forbiddenHeader');
            }
            if (!validateHeaderKeyFormat(key)) {
                key.addClass('invalidFormat');
                fieldValidationErrors.addError(key, 'invalidFormat', 'This header contains invalid characters');
                ok = false;
            } else {
                key.removeClass('invalidFormat');
                fieldValidationErrors.removeError(key, 'invalidFormat');
            }
            if (!validateEmptyHeader(key)) {
                key.addClass('emptyHeader');
                fieldValidationErrors.addError(key, 'emptyHeader', 'This header key must not be empty');
                ok = false;
            } else {
                key.removeClass('emptyHeader');
                fieldValidationErrors.removeError(key, 'emptyHeader');
            }

            // Validate value
            var value = $(this).find('input.value');
            if (!validateEmptyValue(value)) {
                value.addClass('emptyValue');
                fieldValidationErrors.addError(value, 'emptyValue', 'This header value must not be empty');
                ok = false;
            } else {
                value.removeClass('emptyValue');
                fieldValidationErrors.removeError(value, 'emptyValue');
            }
            
            if(!validHeaderValueFormat(value)) {
                value.addClass('invalidFormat');
                fieldValidationErrors.addError(value, 'invalidFormat', 'This header contains invalid characters');
                ok = false;
            } else {
                value.removeClass('invalidFormat');
                fieldValidationErrors.removeError(value, 'invalidFormat');
            }

            if (!validateDuplicateHeaders()) {
                ok = false;
            }

            return ok;
        }
    };

    /**
     * Apply all the validations on submit
     */
    var onSubmit = function(forbiddenHeaders) {
        return function(e) {
            form.enableOnSubmit(e.target);

            var canSubmit = true;
            $('li.headerLine').each(function() {
                if (!validateLine(forbiddenHeaders).call(this) || !validateDuplicateHeaders()) {
                    canSubmit = false;
                }
            });

            return canSubmit;
        };
    };

    /**
     * Add a construct button on header if key is Authorization
     */
    /*
     * TODO Next time var addAuthorizationButton = function(e) { var target = $(e.target); var value = target.val(); if (value.toLowerCase() ==
     * "authorization") { target.val("Authorization"); var parent = target.parent(); var lineNumber = parent.data('lineNumber'); var id = 'construct_' +
     * lineNumber; $('#' + id).remove(); parent.append('<a href="#" id="' + id + '" class="icon-pencil">Construct</a>'); $('#' +
     * id).click(function() { alert("popup"); }); } else { $() } };
     */

    var addEvents = function(container, forbiddenHeaders, customValidation) {
        var addLineAfterLast = function() {
            var line = $(this).parent();
            line.find('input').off('focus.headerLine');

            line.removeClass('last');

            line.find('span.remove-header-line').show();

            var lineNumber = line.data('lineNumber');
            container.append(headerLine(lineNumber + 1, '', '', 'last'));
            addEvents(container, forbiddenHeaders, customValidation);
        };

        container.find('li:last-child input').off('focus.headerLine').on('focus.headerLine', addLineAfterLast);

        container.find('.last input.header').off('keyup.headers').on('keyup.headers', function(e) {
            var keyCode = e.keyCode || e.which;

            if (keyCode == 9) {
                e.preventDefault();
                $.proxy(this, addLineAfterLast);
            }
        });

        container.find('.remove-header-line').off('click.headerLine').on('click.headerLine', function() {
            var span = $(this);
            var lineNumber = span.data("lineNumber");
            $('#header_' + lineNumber).remove();
            addEvents(container, forbiddenHeaders, customValidation);
        });

        container.find('li:only-child .remove-header-line').off('click.headerLine');

        container.find('li.last .remove-header-line').hide();

        $('li.headerLine').off('focusout.headers').on('focusout.headers', validateLine(forbiddenHeaders));

        $('input, textarea').off('mouseover').on('mouseover', function() {
            fieldValidationErrors.updateErrors($(this));
        });

        $('input, textarea').off('focusout.variablesValidation').on('focusout.variablesValidation', function() {
            customValidation($(this));
        });
        // TODO NExt time $('input.header').off('focusout.headers').on('focusout.headers', addAuthorizationButton);
    };

    var buildFromModel = function(containerId, model, forbiddenHeaders, customValidation) {
        var list = $(containerId);
        var i = 0;
        for ( var key in model) {
            if (model.hasOwnProperty(key)) {
                // append a line for each model entry
                list.append(headerLine(i, key, model[key]));
                i++;
            }
        }
        // Append an empty line
        list.append(headerLine(i, "", "", 'last'));
        addEvents(list, forbiddenHeaders, customValidation);
    };

    return {
        'buildFromModel': buildFromModel,
        'onSubmit' : onSubmit
    };
});
